import { decryptedString } from './cryptr';

const asObject = (text) => {
  if (!text) return null;
  try {
    const parsed = JSON.parse(text);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? parsed
      : null;
  } catch {
    return null;
  }
};

// The stored blob is normally an AES string, but a backend may hand back an
// already decoded object or a plain JSON string. Accepting all three keeps a
// format mismatch from silently showing every permission as off.
const decodePolValues = (polValues) => {
  if (!polValues) return {};

  if (typeof polValues === 'object') {
    return Array.isArray(polValues) ? {} : polValues;
  }

  let decrypted = null;
  try {
    decrypted = decryptedString(polValues);
  } catch {
    decrypted = null;
  }

  return asObject(decrypted) || asObject(polValues) || {};
};

export default decodePolValues;
